module.exports = "<div>\n  <sa-content-loader ng-if=\"ctrl.isLoading\"></sa-content-loader>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/modules/vk_login/vk_login.html
// module id = 566
// module chunks = 24